var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    transform: "translate(-1475 -650)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6088",
    "data-name": "Rectangle 6088",
    width: 24,
    height: 24,
    transform: "translate(1475 650)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "youtube-logo-2431",
    transform: "translate(1475 615.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34821",
    "data-name": "Path 34821",
    d: "M23.5,40.558a3.006,3.006,0,0,0-2.122-2.122c-1.871-.5-9.377-.5-9.377-.5s-7.505,0-9.377.5A3.006,3.006,0,0,0,.5,40.558a33.513,33.513,0,0,0,0,11.553,3.006,3.006,0,0,0,2.122,2.122c1.871.5,9.377.5,9.377.5s7.505,0,9.377-.5A3.006,3.006,0,0,0,23.5,52.112a31.225,31.225,0,0,0,.5-5.777A31.225,31.225,0,0,0,23.5,40.558Z",
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34822",
    "data-name": "Path 34822",
    d: "M101.16,95.775l6.286-3.63-6.286-3.63Z",
    transform: "translate(-91.588 -45.81)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.465b3e4a5d867a526492fc19532a0546.svg";
export { ForwardRef as ReactComponent };